import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { cameraBannerBg } from '@assets/images/main/camera';
import { IconGpsDeviceOff, IconGpsDeviceOn, IconGpsTagOff, IconGpsTagOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import { loraGatewayOn, loraGatewayOff, loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm } from '@assets/images/main/index';
import { outdoorBannerBG, outdoorBannerImg } from '@assets/images/main/outdoor';

export default {
  banner: {
    title: '无论是广阔的空间，还是移动的资产，<br/>在 ORBRO 画面上一目了然。',
    desc: '通过GPS追踪车辆、资产和设备的移动，<br/>并通过LTE和LoRA接收器将实时位置信息同步至ORBRO OS。',
    schemeTitle: '了解适合您的户外定位追踪方式',
    bgImg: outdoorBannerBG,
    productImg: outdoorBannerImg,
  },

  bannerData: [
    {
      icon: IconGpsDeviceOn,
      iconInv: IconGpsDeviceOff,
      image: '',
      iconText: 'GPS设备',
      sub: 'New',
      link: '/cn/outdoor/gps',
    },
    {
      icon: IconGpsTagOn,
      iconInv: IconGpsTagOff,
      image: '',
      iconText: 'GPS标签（LoRA）',
      sub: 'New',
      link: '/cn/outdoor/lora',
    },
  ],

  func: {
    title: '查看摄像头功能',
    desc: '了解摄像头的多种功能。',

    data: [
      {
        img: IconBlueShield,
        title: '实时追踪移动路线',
        desc: '可将车辆、设备、集装箱等户外资产的移动路径实时可视化于地图中，轻松掌握当前位置与历史轨迹。',
      },
      {
        img: IconAlarm,
        title: '区域设定与离开检测',
        desc: '可预设港口、堆场、道路施工区域等特定区域，资产出入时自动触发通知。',
      },
      {
        img: Icon3dMeter,
        title: '设备运行时间分析',
        desc: '基于 GPS 数据，自动分类车辆或重型设备的运行、等待、停止时间，从而分析设备利用率。',
      },
      {
        img: Icon3dCycle,
        title: '超速异常检测与通知',
        desc: '当超过设定速度或发生异常运动模式时，系统将自动向管理员发送通知。',
      },
      {
        img: Icon3dDetect,
        title: '远程监控 GPS 终端状态',
        desc: '可远程查看各终端的电池电量、最后通信时间、位置更新频率等，状态异常时发送预警。',
      },
      {
        img: Icon3d3d,
        title: '自动生成资产报告',
        desc: '可基于资产的位置信息、停留区域、行驶距离、进出记录等，自动生成日/周/月的运营报告。',
      },
    ],
  },

  FAQ: [
    {
      title: 'ORBRO 的 GPS 位置追踪系统是如何运作的？',
      description:
        '通过接收 GNSS（GPS）信号的终端设备实时计算户外资产的位置，并通过 LoRA 或 LTE-M 通信发送至 ORBRO Server，位置数据将在 ORBRO OS 上以地图形式可视化。',
    },
    {
      title: 'LoRA 接收套件的作用是什么？',
      description: 'LoRA 接收套件接收 GPS 终端发出的信号，并通过有线（PoE）通信传送至 ORBRO Server，实现大范围区域内的实时位置数据同步。',
    },
    {
      title: '可以在没有电源的户外区域使用吗？',
      description: 'GPS 终端内置电池可持续使用最长达 150 天，因此可在无电源环境下使用。接收器则使用 PoE，需要电源支持。',
    },
    {
      title: '可以实现实时追踪吗？',
      description: '可以。GPS 终端会定期发送位置数据，接收到的数据几乎实时反映在服务器上。传输周期可根据设置进行调整，通常为 10 秒至 1 分钟。',
    },
    {
      title: 'GPS 定位是否优于室内 RTLS？',
      description: '视情况而定。GPS 更适合户外广阔空间和自主移动资产，而 RTLS 更适用于高精度室内追踪。ORBRO 支持室内外一体化管理。',
    },
    {
      title: '位置数据会被保存吗？',
      description:
        '会的。收集到的位置数据将保存在 ORBRO Server 中，并可用于资产移动历史、出入记录、停留时间分析等。所有数据将依据访问权限及加密策略进行安全管理。',
    },
    {
      title: '可以查看终端状态吗？',
      description: '可以。在 ORBRO OS 中可以远程查看每个终端的电池余量、最后通信时间、信号质量等，异常时会自动发送警报通知。',
    },
    {
      title: '可以设置实时提醒吗？',
      description: '可以。当资产离开指定区域、发生异常运动或超速时，系统会通过推送、邮件、Webhook 等方式向管理员发送实时通知。',
    },
  ],
};
